/*
  AA MATCHING CLUTCH — v1.0 · 8 Oct 2026

  Quick view (gallery + zoom), "Add clutch to cart", "Add both", the
  drawer / cart-page "+ Add", and the product page's mobile pill.

  Loading: deferred on product pages that have a matching clutch
  (aa-matching-clutch-card). Elsewhere it is fetched only on the first tap
  of a matching-clutch control (loader in snippets/minicart.liquid).

  Cart updates reuse the theme's own drawer contract, exactly as its
  product form does: POST routes.cart_add_url with the drawer's sections,
  swap each section's #id innerHTML, then cart.cartAction() + cart.open().
  #minicart_wrapper and .minicart__wrapper are never replaced (their
  "open" class is the drawer's state). The rewards bar re-syncs itself
  through its own MutationObserver. On /cart, our "+ Add" reloads the page
  (the only way that page refreshes its rows); the theme's own remove /
  quantity changes re-fetch just our box (watchCartPage).
  "Add both" adds the clutch, then clicks the real Add to Cart button, so
  heel, size, custom-colour and any app options go through untouched.
*/
(function () {
  if (window.AAMC) return;
  window.AAMC = true;

  var MOBILE = '(max-width: 749px)';
  var state = { pop: null, slides: [], i: 0, ctx: '', data: null };

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function dataFor(id) { var el = $('[data-aamc-data="' + id + '"]'); return el ? readJSON(el) : null; }
  function copy() {
    var all = document.querySelectorAll('[data-aamc-copy]');
    return (all.length && readJSON(all[all.length - 1])) || {};
  }
  function drawer() { return document.querySelector('cart-notification'); }
  function onCartPage() { return document.body.classList.contains('template-cart'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  /* The theme's own route object; Shopify's locale-aware root as fallback. */
  function route(key, path) {
    return (window.routes && window.routes[key]) || window.Shopify.routes.root + path;
  }
  /* Image URLs arrive at 1600px (image_url needs a width); swap in the size needed. */
  function sized(src, w) {
    return /[?&]width=\d+/.test(src)
      ? src.replace(/([?&])width=\d+/, '$1width=' + w)
      : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- cart ---------- */
  function addToCart(variantId) {
    var body = new FormData();
    var cart = drawer();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart && !onCartPage()) {
      body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    return fetch(route('cart_add_url', 'cart/add'), {
      method: 'POST',
      body: body,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'error');
        return res;
      });
  }

  function refreshCart(res) {
    if (onCartPage()) { window.location.reload(); return; }
    var cart = drawer();
    if (!cart || !res.sections) return;
    cart.getSectionsToRender().forEach(function (s) {
      var el = document.getElementById(s.id);
      var doc = new DOMParser().parseFromString(res.sections[s.id], 'text/html');
      var fresh = doc.getElementById(s.id);
      if (el && fresh) el.innerHTML = fresh.innerHTML;
    });
    cart.cartAction();
    if (window.BlsLazyloadImg && BlsLazyloadImg.init) BlsLazyloadImg.init();
    reconvert();
    updateCounts();
    cart.open();
  }

  /* Bucks Currency Converter rewrites .money prices into the shopper's
     currency on page load only; ask it to redo prices we add later. */
  function reconvert() {
    var b = window.bucksCC;
    if (!b || !b.reConvert) return;
    try { b.reConvert(); } catch (e) {}
  }

  function updateCounts() {
    fetch(route('cart_url', 'cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.innerHTML = el.classList.contains('cart-count-drawer')
            ? '(' + c.item_count + ')'
            : (c.item_count > 100 ? '~' : c.item_count);
        });
        var total = $('header-total-price');
        if (total && total.updateTotal) total.updateTotal(c);
        var ship = $('free-ship-progress-bar');
        if (ship && ship.init) ship.init(c.items_subtotal_price);
      })
      .catch(function () {});
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.disabled = !!on;
  }

  function fail(btn, err) {
    busy(btn, false);
    if (window.handleErrorMessagePopup) handleErrorMessagePopup(err.message);
  }

  function quickAdd(btn) {
    busy(btn, true);
    addToCart(btn.getAttribute('data-aamc-add'))
      .then(refreshCart)
      .catch(function (e) { fail(btn, e); });
  }

  function mainSubmit() {
    var card = $('[data-aamc-card]');
    var form = card && document.getElementById(card.getAttribute('data-form'));
    var scope = form && (form.closest('product-form') || form);
    var btn = scope && scope.querySelector('[type="submit"]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return null;
    return btn;
  }

  function addClutch(btn) {
    busy(btn, true);
    addToCart(state.data.variant)
      .then(function (res) { closePop(); refreshCart(res); })
      .catch(function (e) { fail(btn, e); });
  }

  function addBoth(btn) {
    var submit = mainSubmit();
    if (!submit) return addClutch(btn);
    busy(btn, true);
    addToCart(state.data.variant)
      .then(function () { closePop(); submit.click(); })
      .catch(function (e) { fail(btn, e); });
  }

  /* ---------- quick view ---------- */
  function openPop(trigger) {
    var d = dataFor(trigger.getAttribute('data-aamc-open'));
    if (!d) return;
    injectCSS();
    closePop(true);
    var t = copy();
    state.data = d;
    state.ctx = trigger.getAttribute('data-aamc-ctx') || '';
    state.i = 0;
    state.slides = d.images.map(function (s) { return { src: s, cap: '' }; });
    if (d.pairImg) state.slides.push({ src: d.pairImg, cap: (t.pairs || '') + ' ' + d.pair });

    var inCart = trigger.hasAttribute('data-aamc-in');
    var both = state.ctx === 'pdp' && mainSubmit();
    var pop = document.createElement('div');
    /* cart-quick-edit-modal: the theme's drawer ignores clicks inside this
       class, so using the quick view never closes an open drawer. */
    pop.className = 'aamc-pop cart-quick-edit-modal';
    pop.innerHTML =
      '<div class="aamc-pop__scrim" data-aamc-close></div>' +
      '<div class="aamc-pop__panel" role="dialog" aria-modal="true" aria-label="' + esc(d.name) + '">' +
        '<button type="button" class="aamc-x" data-aamc-close aria-label="' + esc(t.close) + '">&times;</button>' +
        '<div class="aamc-pop__body">' +
          '<div class="aamc-gal">' +
            '<div class="aamc-gal__main">' +
              '<img class="aamc-gal__img" src="' + esc(sized(state.slides[0].src, 900)) + '" alt="' + esc(d.name) + '">' +
              navButtons(t) +
              '<span class="aamc-gal__cap" hidden></span>' +
              '<div class="aamc-gal__dots">' + state.slides.map(function (_, i) { return '<i' + (i ? '' : ' class="on"') + '></i>'; }).join('') + '</div>' +
            '</div>' +
            '<div class="aamc-gal__th">' + state.slides.map(function (s, i) {
              return '<button type="button" data-aamc-slide="' + i + '"' + (i ? '' : ' class="on"') + '><img src="' + esc(sized(s.src, 160)) + '" alt="" loading="lazy"></button>';
            }).join('') + '</div>' +
          '</div>' +
          '<div class="aamc-info">' +
            '<span class="aamc-info__eb">&#10022; ' + esc(t.eyebrow) + ' &middot; ' + esc(d.pair) + '</span>' +
            '<h3>' + esc(d.name) + '</h3>' +
            (d.sub ? '<div class="aamc-info__sub">' + esc(d.sub) + '</div>' : '') +
            '<div class="aamc-info__price"><span class="money">' + esc(d.price) + '</span></div>' +
            (d.desc ? '<p>' + esc(d.desc) + '</p>' : '') +
            '<a class="aamc-info__more" href="' + esc(d.url) + '">' + esc(t.details) + ' &rarr;</a>' +
            '<div class="aamc-info__btns">' +
              (inCart
                ? '<button type="button" class="aamc-btn aamc-btn--main" disabled>' + esc(t.inCart) + ' &#10003;</button>'
                : '<button type="button" class="aamc-btn aamc-btn--main" data-aamc-addclutch>' + esc(t.add) + '</button>') +
              (both ? '<button type="button" class="aamc-btn aamc-btn--both" data-aamc-addboth>' + esc(t.both) + '</button>' +
                      '<div class="aamc-info__note">' + esc(t.bothNote) + '</div>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    reconvert();
    state.pop = pop;
    state.lastFocus = document.activeElement;
    document.documentElement.classList.add('aamc-lock');
    requestAnimationFrame(function () { pop.classList.add('is-open'); pop.querySelector('.aamc-x').focus(); });
    bindSwipe($('.aamc-gal__main', pop), go);
  }

  function navButtons(t) {
    return '<button type="button" class="aamc-arr aamc-arr--l" data-aamc-go="-1" aria-label="' + esc(t.prev) + '">&lsaquo;</button>' +
           '<button type="button" class="aamc-arr aamc-arr--r" data-aamc-go="1" aria-label="' + esc(t.next) + '">&rsaquo;</button>';
  }

  function show(i) {
    var pop = state.pop;
    if (!pop) return;
    var n = state.slides.length;
    state.i = (i + n) % n;
    var s = state.slides[state.i];
    $('.aamc-gal__img', pop).src = sized(s.src, 900);
    var cap = $('.aamc-gal__cap', pop);
    cap.textContent = s.cap;
    cap.hidden = !s.cap;
    pop.querySelectorAll('.aamc-gal__dots i').forEach(function (d, j) { d.classList.toggle('on', j === state.i); });
    pop.querySelectorAll('[data-aamc-slide]').forEach(function (b, j) { b.classList.toggle('on', j === state.i); });
    var z = $('.aamc-zoom', pop);
    if (z) setZoomSlide(z);
  }

  function go(d) { show(state.i + d); }

  function closePop(now) {
    var pop = state.pop;
    if (!pop) return;
    state.pop = null;
    document.documentElement.classList.remove('aamc-lock');
    if (now === true) { pop.remove(); return; }
    pop.classList.remove('is-open');
    setTimeout(function () { pop.remove(); }, 300);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }

  function bindSwipe(el, fn) {
    var x = null;
    el.addEventListener('touchstart', function (e) { x = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x === null) return;
      var dx = e.changedTouches[0].clientX - x;
      if (Math.abs(dx) > 40) fn(dx < 0 ? 1 : -1);
      x = null;
    });
  }

  /* ---------- zoom ---------- */
  function openZoom() {
    var pop = state.pop;
    if (!pop || $('.aamc-zoom', pop)) return;
    var t = copy();
    var z = document.createElement('div');
    z.className = 'aamc-zoom';
    z.innerHTML =
      '<button type="button" class="aamc-x" data-aamc-zclose aria-label="' + esc(t.close) + '">&times;</button>' +
      '<div class="aamc-zoom__stage"><div class="aamc-zoom__canvas"><img alt=""></div></div>' +
      '<span class="aamc-zoom__hint">' + esc(t.zoomHint) + '</span>' +
      '<div class="aamc-zoom__bar">' + navButtons(t).replace(/aamc-arr /g, 'aamc-arr aamc-arr--bar ') + '<span></span></div>';
    $('.aamc-pop__panel', pop).appendChild(z);
    setZoomSlide(z);
    var stage = $('.aamc-zoom__stage', z);
    stage.addEventListener('click', function (e) { toggleZoom(z, e); });
    dragToPan(stage, z);
  }

  function setZoomSlide(z) {
    z.classList.remove('is-zoomed');
    $('img', z).src = sized(state.slides[state.i].src, 1600);
    $('.aamc-zoom__bar span', z).textContent = (state.i + 1) + ' / ' + state.slides.length;
    sizeZoom(z, 1);
  }

  function sizeZoom(z, k) {
    var stage = $('.aamc-zoom__stage', z);
    var canvas = $('.aamc-zoom__canvas', z);
    var img = $('img', z);
    var w = stage.clientWidth, h = stage.clientHeight, f = Math.min(w, h) * k;
    img.style.width = img.style.height = f + 'px';
    canvas.style.width = Math.max(w, f) + 'px';
    canvas.style.height = Math.max(h, f) + 'px';
    if (k === 1) stage.scrollLeft = stage.scrollTop = 0;
  }

  function toggleZoom(z, e) {
    if (z.__dragged) { z.__dragged = false; return; }
    var stage = $('.aamc-zoom__stage', z);
    var r = $('img', z).getBoundingClientRect();
    var fx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    var fy = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
    var on = z.classList.toggle('is-zoomed');
    sizeZoom(z, on ? 2.6 : 1);
    if (!on) return;
    var size = $('img', z).offsetWidth;
    stage.scrollLeft = fx * size - stage.clientWidth / 2;
    stage.scrollTop = fy * size - stage.clientHeight / 2;
  }

  function dragToPan(stage, z) {
    var d = null;
    stage.addEventListener('mousedown', function (e) {
      if (!z.classList.contains('is-zoomed')) return;
      d = { x: e.clientX, y: e.clientY, l: stage.scrollLeft, t: stage.scrollTop };
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!d) return;
      var dx = e.clientX - d.x, dy = e.clientY - d.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) z.__dragged = true;
      stage.scrollLeft = d.l - dx;
      stage.scrollTop = d.t - dy;
    });
    window.addEventListener('mouseup', function () { d = null; });
  }

  function closeZoom() {
    var z = state.pop && $('.aamc-zoom', state.pop);
    if (z) z.remove();
  }

  /* ---------- mobile pill (product page) ---------- */
  /* ---------- /cart page box ----------
     The cart page updates its rows in place (remove, quantity) without
     re-rendering our box, so after each row change re-fetch this section
     once and swap just the box: a removed shoe drops its clutch. */
  function watchCartPage() {
    var box = $('.aamc-box--page');
    var items = $('cart-items');
    var sec = box && box.closest('.shopify-section');
    if (!sec || !items) return;
    var id = sec.id.replace('shopify-section-', '');
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { syncCartBox(id, items); }, 400);
    }).observe(items, { childList: true, subtree: true });
  }

  function syncCartBox(id, items) {
    fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.aamc-box--page');
        var cur = $('.aamc-box--page');
        if (cur && fresh) cur.replaceWith(fresh);
        else if (cur) cur.remove();
        else if (fresh) items.insertAdjacentElement('afterend', fresh);
        reconvert();
      })
      .catch(function () {});
  }

  function initChip() {
    var card = $('[data-aamc-card]');
    var chip = card && $('[data-aamc-chip]', card);
    if (!chip) return;
    document.body.appendChild(chip); /* fixed position must not sit inside a transformed parent */
    var mq = window.matchMedia(MOBILE);
    var queued = false;
    function update() {
      queued = false;
      var past = card.getBoundingClientRect().bottom < 0;
      var drawerOpen = document.documentElement.classList.contains('open-minicart');
      chip.classList.toggle('is-on', mq.matches && past && !drawerOpen && !state.pop);
      chip.style.setProperty('--aamc-chip-bottom', barOffset() + 'px');
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* Height of the bar pinned to the bottom of the screen right now (on
     phones the theme pins the Add to Cart row itself), found by walking up
     from the real Add to Cart button, so no theme class names are assumed. */
  function barOffset() {
    var el = mainSubmit();
    for (var n = 0; el && n < 8; n++, el = el.parentElement) {
      if (getComputedStyle(el).position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      return Math.round(window.innerHeight - r.top + 10);
    }
    return 16;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var el;
    if ((el = t.closest('[data-aamc-zclose]'))) return closeZoom();
    if ((el = t.closest('[data-aamc-close]'))) return closePop();
    if ((el = t.closest('[data-aamc-go]'))) return go(+el.getAttribute('data-aamc-go'));
    if ((el = t.closest('[data-aamc-slide]'))) return show(+el.getAttribute('data-aamc-slide'));
    if (t.closest('.aamc-zoom')) return;
    if (t.classList.contains('aamc-gal__img')) return openZoom();
    if ((el = t.closest('[data-aamc-addclutch]'))) return addClutch(el);
    if ((el = t.closest('[data-aamc-addboth]'))) return addBoth(el);
    if ((el = t.closest('[data-aamc-open]'))) { e.preventDefault(); return openPop(el); }
    if ((el = t.closest('[data-aamc-add]'))) { e.preventDefault(); return quickAdd(el); }
  });

  document.addEventListener('keydown', function (e) {
    if (!state.pop) return;
    var zoom = $('.aamc-zoom', state.pop);
    if (e.key === 'Escape') return zoom ? closeZoom() : closePop();
    if (e.key === 'ArrowRight') go(1);
    if (e.key === 'ArrowLeft') go(-1);
  });

  /* ---------- styles (injected on first quick view only) ---------- */
  function injectCSS() {
    if ($('#aamc-css')) return;
    var s = document.createElement('style');
    s.id = 'aamc-css';
    s.textContent = [
      'html.aamc-lock{overflow:hidden}',
      '.aamc-pop{position:fixed;inset:0;z-index:2147483000;font-family:inherit}',
      '.aamc-pop__scrim{position:absolute;inset:0;background:rgba(28,10,6,.55);opacity:0;transition:opacity .3s}',
      '.aamc-pop.is-open .aamc-pop__scrim{opacity:1}',
      '.aamc-pop__panel{position:absolute;left:50%;top:50%;width:min(920px,94vw);max-height:90vh;overflow:auto;background:#fff;border-radius:16px;opacity:0;transform:translate(-50%,-46%);transition:transform .35s cubic-bezier(.2,.8,.2,1),opacity .3s}',
      '.aamc-pop.is-open .aamc-pop__panel{opacity:1;transform:translate(-50%,-50%)}',
      '.aamc-pop__body{display:grid;grid-template-columns:1.05fr 1fr}',
      '.aamc-x{position:absolute;top:12px;right:12px;z-index:5;width:38px;height:38px;border:0;border-radius:50%;background:#fff;color:#111;font-size:22px;line-height:1;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.15)}',
      '.aamc-gal{padding:20px 0 20px 20px}',
      '.aamc-gal__main{position:relative;aspect-ratio:1/1;border-radius:10px;overflow:hidden;background:#f3eee8;touch-action:pan-y}',
      '.aamc-gal__img{width:100%;height:100%;object-fit:cover;cursor:zoom-in}',
      '.aamc-arr{position:absolute;top:50%;transform:translateY(-50%);width:36px;height:36px;border:0;border-radius:50%;background:rgba(255,255,255,.95);color:#111;font-size:20px;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.15)}',
      '.aamc-arr--l{left:10px}.aamc-arr--r{right:10px}',
      '.aamc-gal__cap{position:absolute;left:10px;top:10px;padding:4px 10px;border-radius:30px;background:#480a01;color:#f3eedb;font-size:11px}',
      '.aamc-gal__dots{position:absolute;left:0;right:0;bottom:10px;display:flex;justify-content:center;gap:5px}',
      '.aamc-gal__dots i{width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.6)}.aamc-gal__dots i.on{background:#fff}',
      '.aamc-gal__th{display:flex;gap:8px;margin-top:8px;overflow-x:auto}',
      '.aamc-gal__th button{flex:none;padding:0;border:2px solid transparent;border-radius:8px;background:none;cursor:pointer;opacity:.75}',
      '.aamc-gal__th button.on{border-color:var(--btn-primary-bg-color,#144444);opacity:1}',
      '.aamc-gal__th img{display:block;width:56px;height:56px;border-radius:6px;object-fit:cover}',
      '.aamc-info{display:flex;flex-direction:column;gap:10px;padding:26px}',
      '.aamc-info__eb{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#7a5c1e;font-weight:600}',
      '.aamc-info h3{margin:0;font-family:inherit;font-size:26px;font-weight:500;line-height:1.2;color:var(--color-heading,#111)}',
      '.aamc-info__sub{margin-top:-6px;font-size:14px;color:#888}',
      '.aamc-info__price{font-size:22px}',
      '.aamc-info p{margin:0;font-size:14.5px;line-height:1.55;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;overflow:hidden}',
      '.aamc-info__more{align-self:flex-start;margin-top:-4px;font-size:13px;font-weight:600;color:var(--btn-primary-bg-color,#144444);text-decoration:underline;text-underline-offset:3px}',
      '.aamc-info__btns{display:flex;flex-direction:column;gap:8px;margin-top:4px}',
      '.aamc-btn{width:100%;height:50px;border:0;border-radius:var(--btn-radius,30px);font:inherit;font-weight:600;cursor:pointer}',
      '.aamc-btn--main{background:var(--btn-primary-bg-color,#144444);color:var(--btn-primary-color,#fff)}',
      '.aamc-btn--both{background:#701c20;color:#fff}',
      '.aamc-btn[disabled]{opacity:.7;cursor:default}',
      '.aamc-info__note{font-size:12px;color:#888;text-align:center}',
      '.aamc-zoom{position:absolute;inset:0;z-index:6;display:flex;flex-direction:column;background:#fff}',
      '.aamc-zoom__stage{position:relative;flex:1;overflow:auto;cursor:zoom-in;scrollbar-width:none}',
      '.aamc-zoom.is-zoomed .aamc-zoom__stage{cursor:grab}',
      '.aamc-zoom__canvas{display:flex;align-items:center;justify-content:center}',
      '.aamc-zoom__canvas img{display:block;max-width:none;user-select:none;-webkit-user-drag:none}',
      '.aamc-zoom__hint{position:absolute;left:50%;bottom:62px;transform:translateX(-50%);padding:6px 14px;border-radius:30px;background:rgba(17,17,17,.75);color:#fff;font-size:12px;white-space:nowrap;pointer-events:none}',
      '.aamc-zoom.is-zoomed .aamc-zoom__hint{opacity:0}',
      '.aamc-zoom__bar{display:flex;align-items:center;justify-content:center;gap:18px;padding:10px 0 14px}',
      '.aamc-zoom__bar span{min-width:40px;text-align:center;font-size:13px;color:#888}',
      '.aamc-arr--bar{position:static;transform:none;border:1px solid #ebebeb;box-shadow:none}',
      '@media (max-width:749px){',
        '.aamc-pop__panel{left:0;right:0;top:auto;bottom:0;width:auto;max-height:91vh;border-radius:20px 20px 0 0;transform:translateY(100%)}',
        '.aamc-pop.is-open .aamc-pop__panel{transform:none}',
        '.aamc-pop__body{grid-template-columns:1fr}',
        '.aamc-gal{padding:14px 14px 0}',
        '.aamc-info{padding:14px 16px 0;gap:8px}',
        '.aamc-info h3{font-size:22px}',
        '.aamc-info__btns{position:sticky;bottom:0;margin:0 -16px;padding:10px 16px calc(14px + env(safe-area-inset-bottom));background:#fff;box-shadow:0 -10px 16px -10px rgba(0,0,0,.15)}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  initChip();
  watchCartPage();
})();
